"use client";

/**
 * Mirror de permisos del usuario en localStorage para que el sidebar y los
 * gates de UI funcionen offline con el último estado conocido.
 *
 * No reemplaza al servidor — el middleware/APIs siguen siendo la fuente de
 * verdad. Esto es sólo para que la UI no se rompa cuando /api/usuarios/permisos
 * no está alcanzable.
 */

export const PERMISOS_MIRROR_KEY = "cacique_permisos_mirror";

export type PermisoSeccion = {
  seccion: string;
  lectura: boolean;
  escritura: boolean;
};

export type PermisosMirrorData = {
  perfiles: { id: number; nombre: string }[];
  secciones: PermisoSeccion[];
  permisos: string[];
  esAdmin: boolean;
};

export type PermisosMirror = { data: PermisosMirrorData; ts: number };

export function readPermisosMirror(): PermisosMirror | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(PERMISOS_MIRROR_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PermisosMirror;
    if (!parsed || !parsed.data) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writePermisosMirror(data: PermisosMirrorData) {
  if (typeof window === "undefined") return;
  try {
    const payload: PermisosMirror = { data, ts: Date.now() };
    window.localStorage.setItem(PERMISOS_MIRROR_KEY, JSON.stringify(payload));
  } catch {
    /* quota / private mode — ignore */
  }
}

export function clearPermisosMirror() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(PERMISOS_MIRROR_KEY);
  } catch {
    /* ignore */
  }
}
